<!-- footer.component.html -->
<footer class="footer">
  <div class="footer-container">
    <a
      [href]="privacyPolicyUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>
    <span class="separator">|</span>
    <a
      [href]="termsUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms and Conditions
    </a>
  </div>
<div class="d-flex justify-content-center align-items-center d-none d-sm-block">
    Share your feedback with us by emailing &nbsp;
    <a href="mailto:business&#64;perse.energy?subject=Feedback%20mail" class="link-3">business&#64;perse.energy</a>
</div>
</footer>
